import { InstitutionType } from '@do/models';
import type { ValuesOf } from '@do/utils/types';

import type { NavigationItem } from '../types';

export const NavigationTitle = {
  Auctions: 'Auctions',
  Artworks: 'Artworks',
  Selections: 'Selections',
  Artists: 'Artists',
  Curators: 'Curators',
  FAQ: 'FAQ',
  AboutUsUFDA: 'About Us',
  About: 'About',
  News: 'News',
  Contacts: 'Contacts',
  BehindTheScenes: 'Process',
  Biography: 'Biography',
} as const;

export type NavigationTitle = ValuesOf<typeof NavigationTitle>;

export const NavigationLink = {
  Main: '/',
  Auctions: 'auctions',
  Artworks: 'artworks',
  Selections: 'selections',
  Artists: 'artists',
  Curators: 'curators',
  FAQ: 'faq',
  AboutUsUFDA: 'about-us',
  About: 'about',
  News: 'news',
  Contacts: 'contact-us',
  BehindTheScenes: 'process',
  Biography: 'biography',
  Process: 'process',
} as const;

export type NavigationLink = ValuesOf<typeof NavigationLink>;

export const UFDANavigationLinks = [
  {
    title: NavigationTitle.Auctions,
    link: NavigationLink.Auctions,
  },
  {
    title: NavigationTitle.Artworks,
    link: NavigationLink.Artworks,
  },
  {
    title: NavigationTitle.Selections,
    link: NavigationLink.Selections,
  },
  {
    title: NavigationTitle.Artists,
    link: NavigationLink.Artists,
  },
  {
    title: NavigationTitle.Curators,
    link: NavigationLink.Curators,
  },
  {
    title: NavigationTitle.AboutUsUFDA,
    link: NavigationLink.AboutUsUFDA,
  },
  {
    title: NavigationTitle.BehindTheScenes,
    link: NavigationLink.BehindTheScenes,
  },
  {
    title: NavigationTitle.News,
    link: NavigationLink.News,
  },
  {
    title: NavigationTitle.FAQ,
    link: NavigationLink.FAQ,
  },
  {
    title: NavigationTitle.Contacts,
    link: NavigationLink.Contacts,
  },
] as const;

export const navigationLinks = {
  [InstitutionType.Artist]: [
    {
      title: NavigationTitle.Auctions,
      link: NavigationLink.Auctions,
    },
    {
      title: NavigationTitle.Artworks,
      link: NavigationLink.Artworks,
    },
    {
      title: NavigationTitle.Selections,
      link: NavigationLink.Selections,
    },
    {
      title: NavigationTitle.Biography,
      link: NavigationLink.Biography,
    },
    {
      title: NavigationTitle.FAQ,
      link: NavigationLink.FAQ,
    },
    {
      title: NavigationTitle.Contacts,
      link: NavigationLink.Contacts,
    },
  ],
  [InstitutionType.Photographer]: [
    {
      title: NavigationTitle.Auctions,
      link: NavigationLink.Auctions,
    },
    {
      title: NavigationTitle.Artworks,
      link: NavigationLink.Artworks,
    },
    {
      title: NavigationTitle.Selections,
      link: NavigationLink.Selections,
    },
    {
      title: NavigationTitle.Biography,
      link: NavigationLink.Biography,
    },
    {
      title: NavigationTitle.FAQ,
      link: NavigationLink.FAQ,
    },
    {
      title: NavigationTitle.Contacts,
      link: NavigationLink.Contacts,
    },
  ],
  [InstitutionType.Curator]: [
    {
      title: NavigationTitle.Auctions,
      link: NavigationLink.Auctions,
    },
    {
      title: NavigationTitle.Artworks,
      link: NavigationLink.Artworks,
    },
    {
      title: NavigationTitle.Selections,
      link: NavigationLink.Selections,
    },
    {
      title: NavigationTitle.Artists,
      link: NavigationLink.Artists,
    },
    {
      title: NavigationTitle.Biography,
      link: NavigationLink.Biography,
    },
    {
      title: NavigationTitle.FAQ,
      link: NavigationLink.FAQ,
    },
    {
      title: NavigationTitle.Contacts,
      link: NavigationLink.Contacts,
    },
  ],
  [InstitutionType.Gallery]: [
    {
      title: NavigationTitle.Auctions,
      link: NavigationLink.Auctions,
    },
    {
      title: NavigationTitle.Artworks,
      link: NavigationLink.Artworks,
    },
    {
      title: NavigationTitle.Selections,
      link: NavigationLink.Selections,
    },
    {
      title: NavigationTitle.Artists,
      link: NavigationLink.Artists,
    },
    {
      title: NavigationTitle.Curators,
      link: NavigationLink.Curators,
    },
    {
      title: NavigationTitle.About,
      link: NavigationLink.About,
    },
    {
      title: NavigationTitle.FAQ,
      link: NavigationLink.FAQ,
    },
    {
      title: NavigationTitle.Contacts,
      link: NavigationLink.Contacts,
    },
  ],
  [InstitutionType.Agency]: [
    {
      title: NavigationTitle.Auctions,
      link: NavigationLink.Auctions,
    },
    {
      title: NavigationTitle.Artworks,
      link: NavigationLink.Artworks,
    },
    {
      title: NavigationTitle.Selections,
      link: NavigationLink.Selections,
    },
    {
      title: NavigationTitle.Artists,
      link: NavigationLink.Artists,
    },
    {
      title: NavigationTitle.Curators,
      link: NavigationLink.Curators,
    },
    {
      title: NavigationTitle.About,
      link: NavigationLink.About,
    },
    {
      title: NavigationTitle.FAQ,
      link: NavigationLink.FAQ,
    },
    {
      title: NavigationTitle.Contacts,
      link: NavigationLink.Contacts,
    },
  ],
  [InstitutionType.Collector]: [
    {
      title: NavigationTitle.Auctions,
      link: NavigationLink.Auctions,
    },
    {
      title: NavigationTitle.Artworks,
      link: NavigationLink.Artworks,
    },
    {
      title: NavigationTitle.Selections,
      link: NavigationLink.Selections,
    },
    {
      title: NavigationTitle.Artists,
      link: NavigationLink.Artists,
    },
    {
      title: NavigationTitle.Biography,
      link: NavigationLink.Biography,
    },
    {
      title: NavigationTitle.FAQ,
      link: NavigationLink.FAQ,
    },
    {
      title: NavigationTitle.Contacts,
      link: NavigationLink.Contacts,
    },
  ],
} as const satisfies { [key in InstitutionType]: readonly NavigationItem[] };
